import type { ApiRoute, NoBody, NoQueryParams } from "../../api"
import type { WarrantyPublicOfferView } from "./WarrantyPublicOfferView"

export interface GetWarrantyPublicOfferViewPathParams {
	inventoryId: string
}
export interface GetWarrantyPublicOfferViewQueryParams {
	mileageUnit: "km" | "mi"
	mileageValue: number
}

export const getWarrantyPublicOfferViewRoute: ApiRoute<
	GetWarrantyPublicOfferViewPathParams,
	GetWarrantyPublicOfferViewQueryParams | NoQueryParams,
	NoBody,
	WarrantyPublicOfferView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/warranty/public-offer`,
	method: "get",
	path: "/vehicles/:inventoryId/warranty/public-offer",
}
